import { useState } from 'react';
import ImageCard from '@components/common/ImageCard';
import { DATA_BASE_URL } from '@lib/constants';

const galleryImages = [
  {
    src: `${DATA_BASE_URL}/data/robotics/images/frc_sydney_robot_2024.webp`,
    title: 'FRC Sydney Robot 2024',
    category: 'FRC'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/frc_sydney_competition_2024_1.webp`,
    title: 'FRC Sydney Competition',
    category: 'FRC'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/frc_sydney_competition_2024_2.webp`,
    title: 'FRC Sydney Competition',
    category: 'FRC'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/frc_sydney_rookie_inspiration_award_2024.webp`,
    title: 'Rookie Inspiration Award',
    category: 'FRC'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/frc_sydney_rookie_award_ceremony_2024.webp`,
    title: 'Award Ceremony',
    category: 'FRC'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/frc_taipei_robot_2025.webp`,
    title: 'FRC Taipei Robot 2025',
    category: 'FRC'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/frc_taipei_finalist_2025.webp`,
    title: 'FRC Taipei Finalist',
    category: 'FRC'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/frc_taipei_pit_area_2025.webp`,
    title: 'FRC Taipei Pit Area',
    category: 'FRC'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/vex_taipei_2025_1.webp`,
    title: 'VEX Worlds Taipei',
    category: 'VEX'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/vex_taipei_2025_2.webp`,
    title: 'VEX Worlds Taipei',
    category: 'VEX'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/vex_taipei_2025_3.webp`,
    title: 'VEX Worlds Taipei',
    category: 'VEX'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/vex_excellence_award_philippines_nationals_2024.webp`,
    title: 'Excellence Award',
    category: 'VEX'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/vex_philippines_nationals_2024.webp`,
    title: 'Philippines Nationals',
    category: 'VEX'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/vex_philippines_national_award_2024.webp`,
    title: 'National Award',
    category: 'VEX'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/vex_robot_design_nationals_2024.webp`,
    title: 'Robot Design',
    category: 'VEX'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/vex_dallas_2025_1.webp`,
    title: 'VEX Dallas Competition',
    category: 'VEX'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/vex_dallas_2025_2.webp`,
    title: 'VEX Dallas Competition',
    category: 'VEX'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/vex_dallas_team_2025.webp`,
    title: 'VEX Dallas Team',
    category: 'VEX'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/vex_worlds_2022.webp`,
    title: 'VEX Worlds 2022',
    category: 'VEX'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/vex_team_award_2023.webp`,
    title: 'VEX Team Award 2023',
    category: 'VEX'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/team_photo_1.webp`,
    title: 'Team Photo',
    category: 'Team'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/team_photo_2025_oct.webp`,
    title: 'Team Photo October 2025',
    category: 'Team'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/frc_sydney_team_photo_2024.webp`,
    title: 'FRC Sydney Team',
    category: 'Team'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/frc_sydney_team_tsinelas_2024.webp`,
    title: 'FRC Team Tsinelas',
    category: 'Team'
  },
  {
    src: `${DATA_BASE_URL}/data/robotics/images/working_on_robot.webp`,
    title: 'Working on Robot',
    category: 'Team'
  }
];

const PhotographyGallerySection = () => {
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [selectedImage, setSelectedImage] = useState(null);

  const filters = ['All', 'FRC', 'VEX', 'Team'];

  const filteredImages = selectedFilter === 'All'
    ? galleryImages
    : galleryImages.filter(img => img.category === selectedFilter);

  return (
    <section className="py-16 sm:py-20 px-4">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-12">
          <h2
            className="text-3xl sm:text-4xl font-heading font-bold mb-4 tracking-tight"
            style={{ color: 'var(--color-heading)' }}
          >
            Competition Gallery
          </h2>
          <p
            className="text-lg max-w-2xl mx-auto mb-8"
            style={{ color: 'var(--color-subtle)' }}
          >
            Moments captured from competitions around the world
          </p>

          {/* Filter Buttons - Horizontal scroll on mobile */}
          <div className="overflow-x-auto pb-4 scrollbar-hide">
            <div className="flex justify-center gap-3 min-w-max px-4 sm:px-0">
              {filters.map((filter) => (
                <button
                  key={filter}
                  onClick={() => setSelectedFilter(filter)}
                  className="px-5 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap"
                  style={{
                    backgroundColor: selectedFilter === filter ? 'var(--color-accent-6)' : 'var(--color-card-bg)',
                    color: selectedFilter === filter ? 'white' : 'var(--color-card-text)',
                    borderColor: selectedFilter === filter ? 'var(--color-accent-6)' : 'var(--color-border-light)',
                    borderWidth: '1px',
                    borderStyle: 'solid'
                  }}
                >
                  {filter}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Gallery Grid - Horizontal scroll on mobile, grid on desktop */}
        <div className="sm:grid sm:grid-cols-2 lg:grid-cols-3 sm:gap-6 flex sm:flex-none overflow-x-auto gap-6 pb-4 snap-x snap-mandatory scrollbar-hide">
          {filteredImages.map((image, index) => (
            <div
              key={index}
              className="group relative cursor-pointer overflow-hidden rounded-xl flex-shrink-0 w-[85vw] sm:w-auto snap-center"
              onClick={() => setSelectedImage(image)}
              style={{
                borderColor: 'var(--color-border-light)',
                borderWidth: '1px',
                borderStyle: 'solid'
              }}
            >
              <ImageCard
                src={image.src}
                alt={image.title}
                aspectRatio="aspect-square"
                rounded={false}
                shadow={false}
              />
              {/* Overlay on hover */}
              <div
                className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
              >
                <div className="text-center px-4">
                  <div className="text-white text-lg font-bold mb-1">
                    {image.title}
                  </div>
                  <div
                    className="text-sm font-medium"
                    style={{ color: 'var(--color-accent-3)' }}
                  >
                    {image.category}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Lightbox Modal */}
        {selectedImage && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.9)' }}
            onClick={() => setSelectedImage(null)}
          >
            <div className="relative max-w-6xl w-full">
              <button
                className="absolute -top-12 right-0 text-white text-3xl font-bold hover:opacity-70 transition-opacity"
                onClick={() => setSelectedImage(null)}
              >
                ×
              </button>
              <img
                src={selectedImage.src}
                alt={selectedImage.title}
                className="w-full h-auto rounded-lg"
              />
              <div className="text-center mt-4">
                <div className="text-white text-xl font-bold mb-1">
                  {selectedImage.title}
                </div>
                <div
                  className="text-sm font-medium"
                  style={{ color: 'var(--color-accent-3)' }}
                >
                  {selectedImage.category}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default PhotographyGallerySection;
